export default function({ title, subtitle, end }) {
    return (
        <div className="mb-6 md:flex align-items-end">
            <div className="flex-grow-1">
                <div className='text-4xl font-bold text-800 mb-2'>{title}</div>
                <div className="md:flex align-items-end">
                    <div className='text-xl font-medium text-color-secondary flex-grow-1 mb-3 md:mb-0'>{subtitle}</div>
                </div>
            </div>
            <div className="flex justify-content-end">
                {end}
            </div>
        </div>
    )
}